/**
 * Created by Kieran on 30/08/2017.
 */

import sweetAlert from 'sweetalert2';
const alert = {};
alert.install = function (Vue) {
  Vue.prototype.$alert = sweetAlert
};
export default alert;



// WEBPACK FOOTER //
// ./src/plugins/alert/index.js